<template>
  <div class="questionnaire">
    <div class="questionnaire__substrate-wrap">
      <div class="questionnaire__substrate">
        <TelegramConnect />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TelegramConnect from './components/TelegramConnect';

export default {
  components: {
    TelegramConnect
  },
  computed: {
    ...mapState('auth', {
      userData: s => s.data.user,
      getUserData: s => s.meta.getUserData
    })
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      if (!this.gettingUserInfo) {
        await this.$store.dispatch('auth/getUserInfo');
      }
    }
  }
};
</script>
